/*
 * @Descripttion: 
 * @version: 
 * @Author: WDL
 * @Date: 2023-03-14 17:01:27
 * @LastEditors: WDL
 * @LastEditTime: 2023-03-15 10:38:25
 */
import request from "@/utils/request";

//获取banner
function getBanner() {
    return request.get('/cms/content/ac_main_banner')
}
//获取bannerlist
function getBannerList() {
    return request.get('/cms/section/ac_main_banner_list')
}
//获取关于我们图片
function getAboutData() {
    return request.get('/cms/section/ac_main_about_us')
}
//新闻
function getNewsList() {
    return request.get('/cms/section/ac_main_news_group')
}
//我们的ip
function getOurIp() {
    return request.get('/cms/section/ac_main_ourIP')
}
//友情链接
function getLink() {
    return request.get('/cms/section/ac_main_link')
}
//友情链接
function getContact() {
    return request.get('/cms/content/ac_contact')
}
//翻译图片
function getTransLateList() {
    return request.get('/cms/content/ac_translate_img')
}
export default {
    getBanner,
    getBannerList,
    getAboutData,
    getNewsList,
    getOurIp,
    getLink,
    getContact,
    getTransLateList
}